
/**
 * 트윗 태그 정보
 */
export type GetTweets200PageAllOfThreeContentItemTags = {
  hashtags?: string[];
};
